import { render, staticRenderFns } from "./PlacementsTable.vue?vue&type=template&id=21dd6079&"
import script from "./PlacementsTable.vue?vue&type=script&lang=js&"
export * from "./PlacementsTable.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsTable.vue?vue&type=style&index=0&id=21dd6079&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports